import React from 'react'
import AddingControllerfunc from '../android/AddingControllerfunc'

const index = () => <AddingControllerfunc />

export default index